import { useCallback } from 'react';
import { Sizes } from 'enums/sizes';
import { useDialog } from 'hooks/useDialog';
import { useAbp } from 'core/hooks/useAbp';
import { AbpPolicies } from 'core/constants/AbpPolicies';
import { TunnelActionTarget } from '../tunnelActionTarget';
import { DuplicateTunnelModal } from './DuplicateTunnelModal';

/**
 * Ouverture de la modale de duplication, partagée par la liste admin et la fiche du
 * tunnel. La permission ne suffit pas côté back — le rôle administrateur est revérifié à
 * l'exécution — mais elle évite de proposer l'action à qui ne l'a pas du tout ; le refus
 * de rôle, lui, remonte dans la modale avec le message du back.
 */
export const useDuplicateTunnelDialog = () => {
  const { openBlankDialog } = useDialog();
  const { hasPermission } = useAbp();

  const canDuplicate = hasPermission(AbpPolicies.ADMIN_TUNNELS_DUPLICATE);

  const openDuplicateDialog = useCallback(
    (tunnel: TunnelActionTarget, onSuccess?: () => void) =>
      openBlankDialog(
        { size: Sizes['2xl'] },
        <DuplicateTunnelModal tunnel={tunnel} onSuccess={onSuccess} />
      ),
    [openBlankDialog]
  );

  return { canDuplicate, openDuplicateDialog };
};
